var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.001 26.3698C31.5778 25.6792 32.8691 24.4671 33.6581 22.9371C34.4471 21.4071 34.6857 19.6522 34.3339 17.9671C33.9821 16.2819 33.0613 14.7691 31.726 13.6825C30.3908 12.596 28.7224 12.0018 27.001 11.9998H25.111C24.6355 10.1586 23.7293 8.45673 22.467 7.03451C21.2046 5.61229 19.6224 4.51043 17.8506 3.81974C16.0789 3.12906 14.1684 2.86934 12.2765 3.06198C10.3847 3.25462 8.56573 3.89411 6.96956 4.92773C5.37339 5.96136 4.04572 7.35953 3.09598 9.007C2.14624 10.6545 1.60163 12.5041 1.50704 14.4033C1.41245 16.3026 1.77059 18.1971 2.55193 19.9308C3.33327 21.6645 4.51545 23.1877 6.00102 24.3748",
    stroke: "#121D2A",
    strokeWidth: 2.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1277_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1346 22.5001H17.3654C18.1301 22.5001 18.75 21.8802 18.75 21.1155V14.8848C18.75 14.12 18.1301 13.5001 17.3654 13.5001H11.1346C10.3699 13.5001 9.75002 14.12 9.75002 14.8848V21.1155C9.75002 21.8802 10.3699 22.5001 11.1346 22.5001Z",
    fill: "#121D2A",
    stroke: "#121D2A",
    strokeWidth: 2.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6875 19.3124H24.5C24.931 19.3124 25.3443 19.4836 25.649 19.7883C25.9538 20.0931 26.125 20.5064 26.125 20.9374V28.2499C26.125 28.6809 25.9538 29.0942 25.649 29.3989C25.3443 29.7037 24.931 29.8749 24.5 29.8749H17.1875C16.7565 29.8749 16.3432 29.7037 16.0385 29.3989C15.7337 29.0942 15.5625 28.6809 15.5625 28.2499V27.4374",
    stroke: "#121D2A",
    strokeWidth: 2.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9999,
    height: 35.9999,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1277_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 19.5,
    fill: "white",
    transform: "matrix(-1 0 0 -1 27.75 31.5001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudApp);
export default __webpack_public_path__ + "static/media/cloud-app.890f92f301f24a7843587217e801158b.svg";
export { ForwardRef as ReactComponent };